import React from 'react';
import ReactMaskedInput, { MaskedInputProps as ReactMaskedInputProps } from 'react-text-mask';

export interface MaskedInputProps extends ReactMaskedInputProps {
  inputRef?: (ref: HTMLInputElement | null) => void;
}

const MaskedInput: React.FC<MaskedInputProps> = ({ inputRef, ...rest }) => (
  <ReactMaskedInput
    {...rest}
    ref={(ref: any) => {
      if (inputRef) {
        inputRef(ref ? ref.inputElement : null);
      }
    }}
  />
);

export default MaskedInput;
